/*
 * Package Import
 */
import React from "react";
import PropTypes from "prop-types";

/*
 * Local Import
 */
import Format from "../../Format";
import Character from "../Character";

/*
 * Pattern
 */
// Regular expression to match text wrapped in *, ~, or _ without spaces around the symbols
export const patternTextFormat =
	/(\s|^)([*~_])([^\s*~_].+?[^\s*~_])\2(?=\s|$)/g;

/*
 * Get style by character
 */
const getStyle = char => {
	switch (char) {
		case "*":
			return { fontWeight: "bold" };
		case "~":
			return { textDecoration: "line-through" };
		case "_":
			return { fontStyle: "italic" };
		default:
			return {};
	}
};

/*
 * TextFormat Component
 */
const TextFormat = ({ children }) => {
	// Resetting lastIndex ensures exec finds the first match each time it's called
	patternTextFormat.lastIndex = 0;
	const match = patternTextFormat.exec(children);

	// If no match, return the original text without any formatting
	if (!match) return <Character>{children}</Character>;

	const [, before, symbol, text] = match;

	// Render formatted text
	return (
		<React.Fragment>
			{before && <Character>{before}</Character>}
			<span style={getStyle(symbol)}>
				<Format>{text}</Format>
			</span>
		</React.Fragment>
	);
};

/*
 * PropTypes
 */
TextFormat.propTypes = {
	children: PropTypes.string.isRequired,
};

/*
 * Export
 */
export default TextFormat;
